import React from 'react'
import PropTypes from 'prop-types'

// Get styles, which are made by sass
import '../styles/main.scss'

// Get react/gatsby components
import Metadata from '../components/Metadata'
import Header from '../components/Header'
import Footer from '../components/Footer'

// Setup template wrapper
export default class TemplateWrapper extends React.Component {

  // We want to render different base templates depending on the path the user hits
  render() {

    // Intro
    if (this.props.location.pathname === "/") {
      return (
        <div>
          <Metadata />
          <div>
            { this.props.children() }
          </div>
        </div>
      )
    } 
    
    // Locations and Topic Categories
    if (this.props.location.pathname === "/locations/" || this.props.location.pathname === "/locations") {
      return (
        <div>
          <Metadata />
          <Header />
          <div>
            { this.props.children() }
          </div>
        </div>
      )
    }

    // Individual locations and category pages, same as locations right now
    else {
      return (
        <div>
          <Metadata />
          <Header />
          <main className="pfb-wrapper" id="pfb-location-content-wrapper">
            { this.props.children() }
          </main>
          <Footer />
        </div>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/layouts/index.js